<div class="wrapper">
	<div class="container">
		<div class="brd_bx">
			<div class="row">
				<div class="col-lg-12">
					<div class="card m-b-30">
						<div class="card-body">
							<form action="" method="post" id="category_form" enctype="multipart/form-data">
								<div class="row">
									<div class="col-lg-12">
										<div class="card m-b-10">
											<div class="page-title-box row">
												<div class="col-md-6">
													<div class="btn-group ">
														<h4 class="page-title">Epaper Category</h4>
													</div>
												</div>
												<div class="col-md-6">
													<div class="btn-group pull-right">
														<div>
															<button (click)="submit_form()" class="btn btn-success waves-effect waves-light m-r-5">Save Category</button>
															<a href="javascript:void(0);" routerLink="/category-list" type="button"
																class="btn btn-secondary waves-effect m-l-5">Cancel</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">Gujarati Title: </label>
										<div class="col-sm-8">
											<input class="form-control" data-validation="required" type="text" 
												name="gujarati_title" 
												id="gujarati_title" value="{{CategoryData?.gujarati_title}}">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">English Title: </label>
										<div class="col-sm-8">
											<input class="form-control" data-validation="required" type="text" 
												name="english_title" value="{{CategoryData?.english_title}}"
												id="english_title">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">Display Order: </label>
										<div class="col-sm-8">
											<input type="hidden" name="CategoryID" value="{{CategoryData?._id}}">
											<input type="hidden" name="oriDisplayOrder" id="oriDisplayOrder" value="{{CategoryData?.display_order}}">
											<input class="form-control" data-validation="required" type="text" 
												name="display_order" value="{{CategoryData?.display_order}}"
												id="display_order">
										</div>
									</div>
								</div>
								<div class="form-group">
									<div>
										<button (click)="submit_form()" class="btn btn-success waves-effect waves-light m-r-5">Save Category</button>
										<a href="javascript:void(0);" routerLink="/category-list" type="button"
											class="btn btn-secondary waves-effect m-l-5">Cancel</a>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>